<template>
  <div id="index">
    <div class="common-level-rail">
      <el-button type="primary" size="small" icon="el-icon-plus" v-auth="'/graphic/graphic/add'" @click="$refs.addEditRef.show()">添加</el-button>
    </div>

    <div class="product-content">
      <el-table size="small" :data="list" border style="width: 100%">
        <el-table-column prop="key" label="key" width="160"></el-table-column>
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column prop="create_time" label="日期"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="small" v-auth="'/graphic/graphic/edit'" @click="$refs.addEditRef.show(scope.row)">编辑</el-button>
            <el-button type="text" size="small" v-auth="'/graphic/graphic/delete'" @click="deleteRow(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination @current-change="pageChange" background :current-page="searchObj.page" :page-size="searchObj.list_rows" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </div>

    <addEdit ref="addEditRef" @refresh="getData"></addEdit>
  </div>
</template>

<script>
import SettingApi from '@/api/setting.js';
import addEdit from './addEdit.vue';
export default {
  components: { addEdit },
  data() {
    return {
      searchObj: {
        page: 1,
        list_rows: 10,
      },
      list: [],
      total: 0,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      SettingApi.graphicIndex(this.searchObj, true).then(res => {
        this.list = res.data.list.data;
        this.total = res.data.list.total;
      });
    },
    pageChange(e) {
      this.searchObj.page = e;
      this.getData();
    },
    deleteRow(row) {
      this.$confirm('确认删除该图文配置？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        SettingApi.graphicDelete({ graphic_id: row.graphic_id }).then(() => {
          this.$message({ message: '删除成功', type: 'success' });
          this.getData();
        });
      }).catch(() => {});
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/setting/graphic/index.vue